import { type ButtonProps as MUIButtonProps } from "@mui/material/Button";
import { type FC, type PropsWithChildren } from "react";
import { AppBarLinkButton, InternalLinkBaseButton } from "./InternalButtonLink.styled";

export const InternalButtonLinkCustomVariant = {
    AppBarLink: "appBarLink",
    ContactLink: "contactLink",
    Clear: "clear",
} as const;

export type InternalButtonLinkCustomVariant =
    (typeof InternalButtonLinkCustomVariant)[keyof typeof InternalButtonLinkCustomVariant];

export type InternalButtonLinkProps = PropsWithChildren<
    MUIButtonProps & {
        customVariant?: InternalButtonLinkCustomVariant;
        bold?: boolean;
        to?: string;
    }
>;

export const InternalButtonLink: FC<InternalButtonLinkProps> = ({
    children,
    href,
    to,
    variant = "contained",
    customVariant,
    bold,
    ...rest
}) => {
    const ButtonComponent =
        customVariant === InternalButtonLinkCustomVariant.AppBarLink ? AppBarLinkButton : InternalLinkBaseButton;
    const resolvedHref = href ?? to;

    return (
        <ButtonComponent
            href={resolvedHref}
            variant={customVariant ? undefined : variant}
            disableElevation={true}
            sx={{ fontWeight: bold ? "bold" : "normal" }}
            {...rest}
        >
            {children}
        </ButtonComponent>
    );
};
